import React from 'react';
import { TextBox } from '../../../components/ui/TextBox';
import { Button } from '../../../components/ui/Button';
import { Table, Column } from '../../../components/ui/Table';
import { IconButton, EyeIcon, PencilIcon, TrashIcon } from '../../../components/ui/IconButton';
import { Product } from '../../../types/products';
import { formatRupiah } from '../../../utils/format';

export type ListViewProps = {
  data: Product[];
  total: number;
  page: number;
  pageSize: number;
  setPage: (p: number) => void;
  setPageSize: (s: number) => void;
  query: string;
  setQuery: (q: string) => void;
  loading?: boolean;
  error?: string | null;
  onCreate: () => void;
  onView: (id: string) => void;
  onEdit: (id: string) => void;
  onDelete: (id: string) => void;
};

export const ProductsListView: React.FC<ListViewProps> = props => {
  const columns: Column<Product>[] = [
    { key: 'sku', header: 'SKU' },
    { key: 'name', header: 'Name' },
    { key: 'price', header: 'Price', width: 120, render: (row) => formatRupiah(row.price) },
    {
      key: 'actions',
      header: 'Actions',
      width: 140,
      render: (row: Product) => (
        <div className="flex items-center gap-2">
          <IconButton title="View" onClick={() => props.onView(row.id)}>
            <EyeIcon />
          </IconButton>
          <IconButton title="Edit" onClick={() => props.onEdit(row.id)}>
            <PencilIcon />
          </IconButton>
          <IconButton title="Delete" onClick={() => props.onDelete(row.id)}>
            <TrashIcon />
          </IconButton>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className="mb-3 flex items-center justify-between">
        <h1 className="text-xl font-semibold">Products</h1>
        <Button onClick={props.onCreate}>New Product</Button>
      </div>
      <div className="mb-3 flex items-center gap-2">
        <TextBox placeholder="Search by sku or name" value={props.query} onChange={e => props.setQuery(e.target.value)} />
      </div>
      {props.error && <div className="mb-2 text-sm text-destructive">{props.error}</div>}
      <Table
        columns={columns}
        data={props.data}
        page={props.page}
        pageSize={props.pageSize}
        total={props.total}
        onPageChange={props.setPage}
        onPageSizeChange={props.setPageSize}
      />
    </div>
  );
};

export default ProductsListView;
